import { isNil } from "lodash";
import React from "react";

import { useUtilizationDataProvider } from "../../../workforce_metrics";
import { HeatMapItem } from "../heat_map_item/heat_map_item";
import { HeatMap } from "../heat_map_item/heat_map_item.types";
import { useBackgroundColor } from "../helpers/use_background_color";

const BORDER_WIDTH = 1;
const MIN_WIDTH_FOR_SINGLE_DIGIT = 45;
const MIN_WIDTH_FOR_DOUBLE_DIGIT = 55;

const checkShouldDisplayLabel = (value: number | undefined, width: number) =>
  !isNil(value) &&
  ((value < 10 && width > MIN_WIDTH_FOR_SINGLE_DIGIT) || (value >= 10 && width > MIN_WIDTH_FOR_DOUBLE_DIGIT));

type UtilizationItemProps = {
  item: HeatMap;
};

export const UtilizationItem = ({ item }: UtilizationItemProps): JSX.Element => {
  const { getUtilizationValue, getUtilizationLabel } = useUtilizationDataProvider();

  const { nominal_working_minutes: nominalWorkingMinutes, width, left } = item;
  const fullWidth = width - BORDER_WIDTH;
  const utilizationValue = getUtilizationValue(item);
  const isNonWorkingPeriod = utilizationValue === 0 && nominalWorkingMinutes === 0;
  const utilizationLabel = isNonWorkingPeriod ? "" : getUtilizationLabel(utilizationValue);
  const shouldDisplayLabel = checkShouldDisplayLabel(utilizationValue, fullWidth);
  const bgColor = useBackgroundColor(utilizationValue, isNonWorkingPeriod);

  return (
    <HeatMapItem
      {...item}
      left={left}
      width={fullWidth}
      label={utilizationLabel ?? ""}
      bgColor={bgColor}
      shouldDisplayLabel={shouldDisplayLabel}
    />
  );
};
